import { jsxs, jsx } from "react/jsx-runtime";
const IconLocationSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M12 13c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m0-4a1 1 0 1 0 .001 2.001A1 1 0 0 0 12 9" }),
      /* @__PURE__ */ jsx("path", { d: "M12 3a7 7 0 0 1 7 7c0 6-7 11-7 11s-7-5-7-11a7 7 0 0 1 7-7m0-2c-4.963 0-9 4.037-9 9 0 6.95 7.518 12.399 7.838 12.627a2 2 0 0 0 2.324 0C13.482 22.4 21 16.95 21 10c0-4.963-4.037-9-9-9" })
    ]
  }
);
export {
  IconLocationSvg
};
